import React from 'react';
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';

const RoomReservationStatusDropDown = ({ ...props }) => {
  const text = useTextResources();
  const types = [
    {
      value: 'ArrivalToday',
      text: text('ArrivalToday'),
    },
    {
      value: 'DepartureToday',
      text: text('DepartureToday'),
    },
    {
      value: 'StayOver',
      text: text('StayOver'),
    },
    {
      value: 'RoomsWithoutReservations',
      text: text('RoomsWithoutReservations'),
    },
  ];
  return (
    <DropDown
      search={false}
      data={types}
      valueField='value'
      textField='text'
      selection
      clearable
      {...props}
    />
  );
};

export default RoomReservationStatusDropDown;
